import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from "../../../_virtual/_rollupPluginBabelHelpers.js";
import 'react';
import { jsx } from '@emotion/core';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import useStores from "../../../hooks/useStores.js";

var DrawableCheckboxField = function DrawableCheckboxField(_ref) {
  var _assignmentStore$defa;

  var field = _ref.field,
      selected = _ref.selected,
      rest = _objectWithoutProperties(_ref, ["field", "selected"]);

  var data = field.data;
  var checked = !!data.value;

  var _useStores = useStores(),
      assignmentStore = _useStores.assignmentStore;

  var isDefaultAssignmentType = data.assignedTo === ((_assignmentStore$defa = assignmentStore.defaultOption) === null || _assignmentStore$defa === void 0 ? void 0 : _assignmentStore$defa.assignmentKey);
  var x = field.x,
      y = field.y,
      width = field.width,
      height = field.height;

  var toggleChecked = function toggleChecked() {
    if (!isDefaultAssignmentType) return;
    field.updateData({
      value: !checked
    });
  };

  return jsx("g", _extends({}, rest, {
    onDoubleClick: toggleChecked
  }), jsx("rect", {
    className: classnames({
      'bg-primary': isDefaultAssignmentType,
      'border-primary': isDefaultAssignmentType && selected,
      'bg-info': !isDefaultAssignmentType,
      'border-info': !isDefaultAssignmentType && selected
    }),
    fillOpacity: isDefaultAssignmentType ? '0.25' : '0.75',
    x: x,
    y: y,
    width: width,
    height: height
  }), jsx("foreignObject", {
    x: x,
    y: y,
    width: width,
    height: height
  }, jsx("div", {
    role: "checkbox",
    className: classnames(['form-control', 'shadow-none', 'bg-transparent', 'border-0', 'd-flex align-items-center justify-content-center']),
    style: {
      width: width,
      height: height,
      padding: 1
    },
    "aria-checked": checked
  }, checked && jsx("div", {
    className: "fa fa-solid fa-times",
    "data-testid": "checked-checkbox",
    style: {
      fontSize: Math.min(height, width)
    }
  }))));
};

DrawableCheckboxField.displayName = "DrawableCheckboxField";
var DrawableCheckboxField$1 = observer(DrawableCheckboxField);
export default DrawableCheckboxField$1;